/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export default PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.number,
    category: PropTypes.string,
    entrances: PropTypes.arrayOf(PropTypes.shape()),
    divisions: PropTypes.shape(),
    recareas: PropTypes.arrayOf(PropTypes.string),
    components: PropTypes.shape({
        entry_exit_points: PropTypes.bool,
        group_with_fees_and_dates: PropTypes.bool,
        watercraft_list: PropTypes.bool,
    }),
    rules: PropTypes.array,
    travel_methods: PropTypes.array,
    validations: PropTypes.arrayOf(PropTypes.shape()),
});
